fx.ns("shared.renderers", class SocialAlbumRenderer extends fx.Component {
    
	constructor(data, service)
	{
        super(data);

        this._service = service;
    }

    onReady()
    {
        this.on("click", this._onClick);
        if (this.data.isMain)
            this.addClass("main");
    }

    _onClick()
    {
        if (!this.data || typeof this.data.setActiv != "function") return; // trackjs : https://my.trackjs.com/details/3077f5249d46446db7526a536d564cb2
        
        this.data.setActiv();

        if (!this.data.photos.length && !this.data.isLoaded)
            this._service.getPhotos(this.data);
    }

    render()
    {
        let html = "";

        html += "<div class='image " + (this.data.isActive ? 'selected': '') + "' " + "style='background-image: url(" + (this.data.cover_url || "")  +  "'>";
        html += "<div class='text'>";
        html += "<div class='album-name'><strong>" + this.data.name + "</strong></div>";
        if (!this.data.isMain)
            html += "<div class='album-count'>" + this.data.count + " photos</div>";
        html += "</div>";

        return html;
    }

}); 